export default "__VITE_ASSET__COuifAPc__"